import { TextField } from '@mui/material';
import type { FieldRendererProps } from '../types';

export function TextInput({ name, label, required, value, error, onChange }: FieldRendererProps) {
  return (
    <TextField
      name={name}
      label={label}
      required={required}
      value={(value as string | null) ?? ''}
      onChange={(e) => onChange(e.target.value)}
      error={!!error}
      helperText={error ?? undefined}
    />
  );
}
